import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { MsalModule } from "@azure/msal-angular";

import { AuthFlowService } from "./core/auth/auth-flow.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  imports: [CommonModule, RouterOutlet, MsalModule],
})
export class AppComponent implements OnInit {
  title = "GOKURI";
  isIframe = false;

  constructor(private authFlow: AuthFlowService) {}

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;
    this.authFlow.init();
  }
}
